const isFormDataValid = (formFields, formData)=>{
    return formFields.every((field)=>field.disabled || !field.required || formData && formData[field.field] && formData[field.field] !== ''
    );
};

export { isFormDataValid };
//# sourceMappingURL=validate-form-data.js.map
